module.exports = __webpack_public_path__ + "static/media/slack-logo-full.b85a9d65.png";